export default __webpack_public_path__ + "static/media/16e972c2edfb2cd5daf57357388eff0b.40603472.svg";